"use client";

const SUGGESTIONS = [
  { label: "Best risk-adjusted APR pools?", prompt: "Best risk-adjusted APR pools?" },
  { label: "Compare Aquarius vs Soroswap", prompt: "Compare Aquarius vs Soroswap" },
  { label: "Explain impermanent loss", prompt: "Explain impermanent loss" },
  { label: "Safest yield strategy on Stellar?", prompt: "Safest yield strategy on Stellar?" },
];

interface Props {
  onSelect: (prompt: string) => void;
}

export function SuggestedQuestions({ onSelect }: Props) {
  return (
    <div className="flex flex-wrap gap-2 justify-center">
      {SUGGESTIONS.map((s) => (
        <button
          key={s.label}
          onClick={() => { onSelect(s.prompt); }}
          className="rounded-full px-4 py-2 text-[11px] tracking-wide
            border border-[var(--border-subtle)] text-[var(--text-secondary)]
            hover:border-[var(--accent)] hover:text-[var(--accent)]
            transition-colors duration-200 cursor-pointer"
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
